import { TextFieldProps } from "@flat-ui";

/**
 * The space under a form field, separating it from whatever follows. It is page layout rather
 * than the field's look, so it is set on each field's FormControl where the forms place it,
 * not in the theme, which leaves the field itself to flat-ui.
 */
export const fieldSpacingSx: TextFieldProps["controlStyle"] = {
  marginBottom: "24px",
};
